/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'virtual-service';
const componentName = 'vh-match-rule-grid';
const prefix = `${moduleName}.${componentName}`;

export const rulesLabel = `${prefix}.rulesLabel`;

export const ENGLISH = {
    [rulesLabel]: 'Rules ({0})',
};
